import Image from 'next/image';
import type { IntlShape } from 'react-intl';
import type { LanguageRegionCode } from '@alltrails/types/LanguageRegionCode';
import { APP_STORE_URL_MAP } from '../Footer/StoreBadges/AppStore';

type StackedAppStoreBadgeProps = {
  intl: IntlShape;
  languageRegionCode: LanguageRegionCode;
  height?: number;
};

// uniform-width App Store badge, sized to stack with StackedGooglePlayBadge
const StackedAppStoreBadge = ({ intl, languageRegionCode, height = 54 }: StackedAppStoreBadgeProps) => {
  // eslint-disable-next-line @typescript-eslint/no-require-imports, import/no-dynamic-require
  const src = require(`./app-apple-${languageRegionCode}.svg`).default;

  return (
    <a href={APP_STORE_URL_MAP[languageRegionCode]} target="_blank" rel="noreferrer">
      <Image alt={intl.formatMessage({ defaultMessage: 'Download the AllTrails application on the App Store' })} height={height} src={src} />
    </a>
  );
};

export default StackedAppStoreBadge;
